export const GET_JOB_SCREENING_QUESTIONS_REQUEST = 'GET_JOB_SCREENING_QUESTIONS_REQUEST'
export const GET_JOB_SCREENING_QUESTIONS_RECEIVE = 'GET_JOB_SCREENING_QUESTIONS_RECEIVE'

export const APPLY_JOB_REQUEST = 'APPLY_JOB_REQUEST';
export const APPLY_JOB_RECEIVE = 'APPLY_JOB_RECEIVE';